import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Facebook, Instagram, LucideIconData, Mail, MapPin, MessageCircle, Music2, Phone } from 'lucide-angular';

import { PERRON_COINS_COPY } from '../../features/perron-coins/perron-coins.copy';
import { IconComponent } from '../../shared/ui/icon/icon.component';
import { NewsletterFormComponent } from '../../shared/ui/newsletter-form/newsletter-form.component';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, RouterLink, IconComponent, NewsletterFormComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected readonly currentYear = new Date().getFullYear();
  protected readonly coinsCopy = PERRON_COINS_COPY;

  protected readonly instagramIcon: LucideIconData = Instagram;
  protected readonly facebookIcon: LucideIconData = Facebook;
  protected readonly tiktokIcon: LucideIconData = Music2;
  protected readonly whatsappIcon: LucideIconData = MessageCircle;
  protected readonly mailIcon: LucideIconData = Mail;
  protected readonly mapPinIcon: LucideIconData = MapPin;
  protected readonly phoneIcon: LucideIconData = Phone;

  protected readonly contactInfo = {
    email: 'hola@perronstore.com',
    phone: '+506 8912-5220',
    whatsapp: 'https://wa.me/50689125220',
    address: 'Zapote, San José, Costa Rica',
    mapsUrl:
      'https://maps.google.com/?q=Plaza+Del+Castillo+Zapote+San+Jose+Costa+Rica',
    wazeUrl: 'https://ul.waze.com/ul?venue_id=180813923.1808466912.25261033',
    mapsLogo: 'images/logo/g_maps_logo.png',
    wazeLogo: 'images/logo/waze_logo.png',
  };
}
